/* @refresh reload */
import { render } from 'solid-js/web';
import { App } from './App';
import './styles/app.css';
import './templates/styles/templates.css';
import './pages/welcome.css';
import 'katex/dist/katex.min.css';

render(() => <App />, document.getElementById('root')!);
